import Header from "../../components/common/Layouts/Header";
import Footer from "../../components/common/Layouts/Footer";
import HelmetWrapper from "../../components/common/Layouts/HelmetWrapper";
import privacyPolicyContent from "../../assets/data/companyInfos/privacyPolicy.json";
import "../../assets/styles/components_styles/legalDocs.css";

const BLOCK_RENDERERS = {
  updated: ({ text }, key) => (
    <p key={key} className="legalDocsUpdatedDate">
      {text}
    </p>
  ),
  heading: ({ text }, key) => (
    <h2 key={key} className="legalDocsHeading">
      {text}
    </h2>
  ),
  p: ({ text }, key) => (
    <p key={key} className="legalDocsParagraph">
      {text}
    </p>
  ),
};

const renderPolicyBlock = (block, index) => {
  const renderer = BLOCK_RENDERERS[block?.type] || BLOCK_RENDERERS.p;
  return renderer(block, `${block?.type || "p"}-${index}`);
};

export default function PrivacyPolicyPage() {
  const { meta = {}, blocks = [] } = privacyPolicyContent;
  const pageTitle = meta.pageTitle || "Privacy Policy";
  const helmetTitle = meta.helmetTitle || "Privacy Policy - Pingvite";
  const helmetDescription =
    meta.helmetDescription ||
    "Read Pingvite's privacy policy and learn how we collect, use, and protect personal information.";
  const helmetKeywords =
    meta.helmetKeywords || "Pingvite privacy policy, data privacy, personal data";

  return (
    <>
      <HelmetWrapper
        title={helmetTitle}
        description={helmetDescription}
        keywords={helmetKeywords}
      />

      {/* HEADER */}
      <Header isHome={false} />

      {/* CONTENT */}
      <main className="legalDocsPageRoot">
        <section className="legalDocsSection">
          <div className="container">
            <div className="legalDocsContent">
              <h1 className="legalDocsTitle">{pageTitle}</h1>
              <span className="legalDocsTitleUnderline" />

              {blocks.map(renderPolicyBlock)}
            </div>
          </div>
        </section>

        {/* FOOTER */}
        <Footer />
      </main>
    </>
  );
}